import type { CommonStore } from './interfaces'

import { PageType } from '@shared/config'

export const getters = {
  isLoading: (state: CommonStore): CommonStore['loading'] => state.loading,
  getPageType: (state: CommonStore): PageType => state.pageType,
  isMathLanding: (state: CommonStore): boolean => state.pageType === PageType.Math,
  isElaLanding: (state: CommonStore): boolean => state.pageType === PageType.Ela,
  isDemoLanding: (state: CommonStore): boolean => state.pageType === PageType.Demo,
  isModalTutorApplication: (state: CommonStore): boolean => state.modalTutorApplication,
  isModalTutorApplicationSuccess: (state: CommonStore): boolean => state.modalTutorApplicationSuccess,
}
